export const CACHE_NETWORK: any = 'network';

export const CACHE_MEMORY: any = 'memory';

export const CACHE_DISK: any = 'disk';
